import { useFeatureFlags } from 'core/app/AppContext';
import {
  EmbeddedSelectorRequiredRule,
  EmbeddedPositionRequiredRule,
  DisplayWebContentTemplateRequiredRule,
} from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Workflow/Rules';
import { useWorkflowForm } from '../../../../../contexts/CampaignWorkflowFormContext';
import { useDisplayWebContent } from '../../hooks/useDisplayWebContent';

export const useShouldShowMissingFieldsWarning = (id: string) => {
  const { flagEnabled } = useFeatureFlags();
  const { state: formState } = useWorkflowForm();

  const { getTemplate, getDisplayWebContent } = useDisplayWebContent();

  const template = getTemplate(id);
  const displayWebContent = getDisplayWebContent(id);

  const embeddedResult =
    flagEnabled('ld-embedded-content') && template?.isEmbedded
      ? EmbeddedSelectorRequiredRule({ selector: displayWebContent?.embeddedSelector }).result === 'fail' ||
        EmbeddedPositionRequiredRule({ position: displayWebContent?.embeddedPosition }).result === 'fail'
      : false;

  return (
    (DisplayWebContentTemplateRequiredRule({ template }).result === 'fail' || embeddedResult) &&
    !formState.focused[id] &&
    formState.touched[id]
  );
};
